export default {
  loading: false,
  quotations: [],
  quotation: null,
  requote: null,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quotations/store/state.js